import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExitFullScreenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ExitFullScreen",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m26.72 2.58-7.44 7.44V4.35c0-1.1-.89-1.99-1.99-1.99s-1.99.89-1.99 1.99v10.27c0 1.1.88 1.99 1.97 1.99h10.3c.54 0 1.03-.22 1.38-.58a1.989 1.989 0 0 0-1.39-3.41h-5.54l7.36-7.36a1.888 1.888 0 1 0-2.67-2.67ZM5.13 29.53l7.44-7.44v5.82c0 1.1.89 2 2 2s2-.89 2-2V17.55c0-.55-.23-1.05-.59-1.41s-.85-.59-1.4-.59H4.34c-1.1 0-1.99.89-1.99 1.99s.89 1.99 1.99 1.99h5.54L2.46 26.9c-.29.33-.46.76-.46 1.24a1.888 1.888 0 0 0 3.12 1.43s0-.04 0-.04Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19 13.28c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l9.14-9.14a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-9.14 9.14c-.22.22-.52.33-.81.33M3 29.28c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l9.14-9.14a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-9.14 9.14c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 13.28H19c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v8h8a1.14 1.14 0 1 1 0 2.28M12.14 29.28c-.63 0-1.14-.51-1.14-1.14v-8H3a1.14 1.14 0 1 1 0-2.28h9.14c.63 0 1.14.51 1.14 1.14v9.14c0 .63-.51 1.14-1.14 1.14"
      })]
    })
  }));
};
ExitFullScreenIcon.displayName = 'ExitFullScreenIcon';